// removed by extract-text-webpack-plugin
module.exports = {"callout":"callout__callout___1LDq-","heading":"callout__heading___1Rh_9","danger":"callout__danger___1ljLp","warning":"callout__warning___2MhVg"};


//////////////////
// WEBPACK FOOTER
// ./js/components/callout/callout.scss
// module id = 195
// module chunks = 0 1